export function normalizeRecipeSummaries(data) {
  if (!Array.isArray(data)) return [];

  return data.reduce((recipes, item) => {
    if (typeof item === 'string') {
      recipes.push({ dishName: item, imageURL: null, slug: null });
    } else if (item && typeof item.dishName === 'string') {
      recipes.push({
        dishName: item.dishName,
        imageURL: item.imageURL || null,
        slug: item.slug || null,
      });
    }

    return recipes;
  }, []);
}
